import { caaMetricsRepositoryAdapter } from '../../infra/repositories/caaMetricsRepositoryAdapter'

export function GetOperationalCAAMetricsTherapistYearCase(
  repository: ReturnType<typeof caaMetricsRepositoryAdapter>
) {
  return async (params: { personaName?: string; year: number }) => {
    return await repository.getOperationalCAAMetricsTherapistYear(params)
  }
}
